(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureSectionReviewSectionController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.setSectionBlock = function (sectionBlock) {
            $scope.sectionBlock = sectionBlock;
        }

        $scope.setDiffSectionBlock = function (previous, next, diff) {
            $scope.sectionBlock = diff;
            $scope.previous = previous;
            $scope.next = next;
            $scope.diff = diff;

            initLookupAttributeValueReferences();
            $scope.hasReferences = (previous.attachment && $scope.isAttachmentVisible(previous.attachment))
                || (previous.ControlReferences && previous.ControlReferences.length)
                || (previous.LookupReferences && previous.LookupReferences.length)
                || (next.attachment && $scope.isAttachmentVisible(next.attachment))
                || (next.ControlReferences && next.ControlReferences.length)
                || (next.LookupReferences && next.LookupReferences.length);
            $scope.hasFootnotes = previous['Footnotes' + $scope.ctxtCtrl.lang].length || next['Footnotes' + $scope.ctxtCtrl.lang].length;
        }


        function initLookupAttributeValueReferences() {

            var sectionBlockLookupsByAttributeID = {};

            _.forOwn($scope.sectionBlockLookups, function (lookupAttribute) {
                sectionBlockLookupsByAttributeID[lookupAttribute.LookupAttributeID] = lookupAttribute;
            });

            $scope.sectionPreviousCtxtCtrl = {

                // References
                lookupReferences: {
                    ProcessOutput: []
                }
            };
            // Group lookup attribute values by Lookup Attribute Code and assign to the context object
            // for the previous object
            var previousGroupedAttrValues =
                _.groupBy($scope.previous.LookupReferences, 'LookupAttributeID');

            _.forOwn(previousGroupedAttrValues, function (lookupAttributeValues, lookupAttrId) {
                var lookupAttribute = sectionBlockLookupsByAttributeID[lookupAttrId];

                $scope.sectionPreviousCtxtCtrl.lookupReferences[lookupAttribute.Code] = lookupAttributeValues;
            });

            $scope.sectionNextCtxtCtrl = {

                // References
                lookupReferences: {
                    ProcessOutput: []
                }
            };
            // Group lookup attribute values by Lookup Attribute Code and assign to the context object
            // for the next object
            var nextGroupedAttrValues =
                _.groupBy($scope.next.LookupReferences, 'LookupAttributeID');

            _.forOwn(nextGroupedAttrValues, function (lookupAttributeValues, lookupAttrId) {
                var lookupAttribute = sectionBlockLookupsByAttributeID[lookupAttrId];

                $scope.sectionNextCtxtCtrl.lookupReferences[lookupAttribute.Code] = lookupAttributeValues;
            });

        }
    }
})();
